import i18n from 'shared/lib/i18n';

export const getCommunityScopeOptions = () => [
  {
    label: i18n.t('community.allContent'),
    value: 'all_content',
  },
  {
    label: i18n.t('title.post'),
    value: 'post',
  },
  {
    label: i18n.t('community.marketplace'),
    value: 'marketplace',
  },
  {
    label: i18n.t('title.recommendation'),
    value: 'recommendation',
  },
];

export const getCommunityStatusOptions = () => [
  {
    label: i18n.t('status.approved'),
    value: 'approved',
  },
  {
    label: i18n.t('status.declined'),
    value: 'declined',
  },
  {
    label: i18n.t('status.auto'),
    value: 'auto',
  },
  {
    label: i18n.t('status.pendingPosts'),
    value: 'pending',
  },
  {
    label: i18n.t('status.pendingPostsAndComments'),
    value: 'all_pending',
  },
];
